// apis/trialApi.js
import Base_URL from '../config/apiConfig';
import axiosInstance from './axiosInstance';
import ORCH_BASE_URL from '../config/orchConfig';
import orchestratorAxios from './orchestratorAxios';
// import axios from 'axios';

export const sendTrialData = async (data) => {
  const res = await axiosInstance.post(`${Base_URL}/email/send`, data);
  return res.data;
};

export const submitPublicReview = async (reviewData) => {
  try {
    const response = await orchestratorAxios.post(
      `${ORCH_BASE_URL}/admin/reviews/add-public-review`,
      {
        name: reviewData.name,
        email: reviewData.email,
        rating: reviewData.rating,
        review_text: reviewData.review_text,
        organization: reviewData.organization,
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      '❌ Error submitting public review:',
      error.response?.data || error.message,
    );
    throw error;
  }
};
